export class SnexLsClient {
    // Secretly, this is LightstreamerClient. This has no other methods or members;
    // instead, SnexLsBackEnd operates on it
    src: any;
    constructor (src: any) { this.src = src }
}
